<template>
  <v-app-bar app clipped-left flat class="app-top-bar">
    <div class="brand-wrap" @click="$router.push('/')">
      <v-icon color="primary" class="mr-1">mdi-minus</v-icon>
      <span class="brand-smpl">smpl</span>
      <span class="brand-sale">sale</span>
    </div>

    <v-app-bar-nav-icon class="nav-toggle" @click.stop="drawerToggle" />

    <div class="business-wrap">
      <div class="business-name">
        {{ currentBusiness ? currentBusiness.name : "" }}
      </div>
    </div>

    <v-spacer />

    <UserMenu />
  </v-app-bar>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import customerService from "@/modules/Customer/service.js";
import UserMenu from "./Menu";

export default {
  name: "layout-app-bar",

  components: {
    UserMenu,
  },

  data() {
    return {
      Customer: [],
      selectedCustomer: null,
      loading: false,
      customerSearch: null,
    };
  },

  computed: {
    ...mapGetters("global", ["currentBusiness"]),
  },

  watch: {
    selectedCustomer(val) {
      if (val) {
        this.$router.push({ path: `/customer/${val.id}/profile` });
      }
    },
  },

  created() {
    this.getCustomerList();
  },

  methods: {
    ...mapActions("layout", ["drawerToggle"]),

    getCustomerList() {
      this.loading = true;

      return customerService
        .getAll()
        .then((response) => {
          this.Customer = response.data || [];
          return response;
        })
        .catch((error) => {
          console.error("customer list failed", error);
          this.Customer = [];
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style scoped>
.app-top-bar {
  background: #ffffff !important;
  border-bottom: 1px solid #e2e8f0 !important;
}

.brand-wrap {
  display: flex;
  align-items: center;
  cursor: pointer;
  padding: 0 12px 0 4px;
  font-size: 24px;
  line-height: 1;
  white-space: nowrap;
}

.brand-smpl {
  color: #50e3c2;
  font-weight: 400;
  margin-right: 2px;
}

.brand-sale {
  color: #0f172a;
  font-weight: 900;
}

.nav-toggle {
  margin-right: 10px;
}

.business-wrap {
  min-width: 0;
}

.business-name {
  font-size: 18px;
  font-weight: 800;
  color: #0f172a;
  text-transform: capitalize;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 360px;
}

@media (max-width: 600px) {
  .brand-wrap {
    display: none;
  }

  .business-name {
    font-size: 16px;
    max-width: 180px;
  }

  .nav-toggle {
    margin-right: 4px;
  }
}
</style>